export default __webpack_public_path__ + "static/media/x-axis.4e685700.svg";